/**
 * @enum {number}
 */
export const ContentType = {
  ACTIVITY: 'activity',
  ADAPTIVE_TEST: 'adaptive-test',
  DIFFERENTIATED_TEST: 'differentiated-test',
  BOOKS: 'books',
  GAME: 'game',
  GEOMETRY: 'geometry',
  HOMEWORK: 'homework',
  LESSON: 'lesson',
  PDF_ASSIGNMENT: 'pdf-assignment',
  SELF_TRAINING: 'self-training',
  STANDARD_EXERCISE: 'standard-exercise',
  TRIAL_EXAM: 'trial-exam',
  UNKNOWN: 'unknown',
}

/**
 * @enum {number}
 */
export const ChapterSectionType = {
  INTRO: 0,
  LESSON: 1,
  TRIAL_EXAM: 2,
}

/**
 * @enum {number}
 */
export const HomeworkElementModel = {
  LESSON: 1,
  STANDARDEXERCISE: 2,
  ADAPTIVETEST: 3,
  GEOMETRYTEST: 4,
  GAMETEST: 5,
  DIFFERENTIATEDTEST: 6,
}

/**
 * @enum {number}
 */
export const LessonSectionType = {
  HTML: 1,
  VIDEO: 2,
  QUESTION: 3,
  PICTURE: 4,
  GEOGEBRA: 5,
}

/**
 * @enum {number}
 */
export const LessonUnderstood = {
  YES: 1,
  SOMEWHAT: 2,
  NO: 3,
  NONE: 0,
}

/**
 * @enum {number}
 */
export const MetaModelType = {
  UNKNOWN: -1,
  LESSON: 1,
  STANDARDEXERCISE: 2,
  ADAPTIVETEST: 3,
  GEOMETRY: 4,
  GAME: 5,
  DIFFERENTIATEDTEST: 6,
  PDFASSIGNMENT: 7,
  ACTIVITY: 8,
  BOOKS: 99,
  HOMEWORK: 100,
}

/**
 * @enum {string}
 */
export const UserType = {
  ADMIN: 'admin',
  LICENSEE: 'licensee',
  PARENT: 'parents',
  STUDENT: 'student',
  TEACHER: 'teacher',
}

/**
 * @enum {number}
 */
export const QuestionType = {
  INPUT_FIELD: 1,
  MULTIPLE_CHOICE: 2,
}

/**
 * @enum {number}
 */
export const UserAnswerModel = {
  STANDARD: 2,
  ADAPTIVE: 3,
  GAME: 5,
  DIFFERENTIATED: 6,
  TESTSTANDARD: 101,
  TEST5SHARP: 102,
  TESTTRIALEXAM: 103,
  TESTCALENDAR: 104,
}
